import { Input, Tag } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import { getBlueprintConfigApi } from "../../../../api/candidate";
import WebUtils from "../../../../utils/WebUtils";
import SelectedBlueprintForm from "../SelectedBlueprintForm";
import { getIDronaConfig } from "../../../../api/org-admin";

function IDronaConfig({
  userDetail,
  iDronaId,
  setLoading,
  jdDetails,
  jdId,
  interviewDetailsFlag = false
}) {
  const [configData, setConfigData] = useState(null);
  const [disableEdit, setDisableEdit] = useState(true);
  const formatDisplayDate = (dateString) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  // iDronaInterviewConfigurationId=IDRONA_CONFIG_Y517800
  const getConfigData = (id, name, type) => {
    const url = `${getIDronaConfig}?organizationId=${
      userDetail?.organizationId || null
    }&iDronaInterviewConfigurationId=${iDronaId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          // console.log(result.data.data);
          setConfigData(result.data.data);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getConfigData();
  }, []);
  
  return (
    <div className="mb-2 max-w-[1100px] mx-auto">
      {configData?.blueprintVariables ? (
        <>
          <SelectedBlueprintForm
            disableEdit={disableEdit}
            setDisableEdit={setDisableEdit}
            selectedAutoFillData={configData}
            jdDetails={jdDetails}
            userDetail={userDetail}
            jdId={jdId}
            iDronaId={iDronaId}
            setLoading={setLoading}
            iDronaConfigFlag={interviewDetailsFlag}
            noBackButton={true}
          />
        </>
      ) : (
        <div className="mx-auto  text-gray-500 font-medium text-[1.05rem]">
          <div className="mx-auto flex justify-center items-center">
            {/* <img src={emptySvg} alt="" /> */}
          </div>
          <div className="text-center">Invalid iDrona ID.</div>
          {/* <div className="text-center">
            Please reach out to your Account Manager to enable and use this
            Maya.
          </div> */}
        </div>
      )}
    </div>
  );
}

export default IDronaConfig;
